export default "__VITE_ASSET__a0f3a56a__"